import { EMPTY_OBJECT } from 'commons-ui';

import { URL, APK_UPDATE_RESOURCES } from '../../helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'view':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.superAppUpdateLogs]}/view`,
					state: {
						rowData
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
